(function(window, document) {

	/* ---------------------------------------- [START] Hash 更換 */
	const faqList = $('#faq-list');
	const $tab = $('#faq-tabs');
	let hash;

	// Check Faq hash and Stop Scroll
	// Ref: https://gist.github.com/srikat/10812884#file-gistfile4-js
	function checkHash(){
		return new Promise ((resolve, reject) => {
			// location
			hash = location.hash;

			if (hash === '') {
				return reject;
			}

			const $hashTarget = faqList.find(hash);
		
			if ($hashTarget.length !== 0) {
					// 有目標的情況
					if ($hashTarget.hasClass('accordion-content')) {
						// 是題目
						window.addEventListener('load', function() {
							resolve('accordion');
						});
					} else {
						// 是Tab
						resolve('tab');
					}
			} else {
				return reject;
			}
		});

	}

	checkHash().then((result) => {
		if (result === 'tab') {
			// 是Tab
			// 讓頁面跳到最上面
			$('html, body').stop().animate({'scrollTop': 0}, 500);
			// window.scrollTo(0, 0);
		} else if (result === 'accordion') {
			// 是題目
			faqHighlight(hash)
		}
	}) ;

	function faqHighlight(hash) {
		const $el = $(hash);
		const $targetTab = $el.parents('.tabs-panel');
		const $targetAccordion = $el.parents('.accordion');

		$tab.foundation('selectTab', $targetTab); // 開Tab: 會更新hash
		$targetAccordion.foundation('down', $el); // 開Accordion: 不會更新hash
		history.replaceState({}, '', hash); // 更新hash
	
		var $parent = $el.parent();
		$parent.addClass('is-highlight');

		document.addEventListener('mousewheel', stopMouseWheel);

		$('html, body').stop().animate({'scrollTop': $parent.offset().top - $(header).innerHeight()}, 500, function(){
			document.removeEventListener('mousewheel', stopMouseWheel);

			setTimeout(function(){
				$parent.removeClass('is-highlight');
			}, 2000);
		});
	}

	// Reference: http://solidlystated.com/scripting/javascript-disable-mouse-wheel/
	function stopMouseWheel(e){
		if(!e){ e = window.event; } /* IE7, IE8, Chrome, Safari */
		if(e.preventDefault) { e.preventDefault(); } /* Chrome, Safari, Firefox */
		e.returnValue = false; /* IE7, IE8 */
	}

	/* ---------------------------------------- [END] Hash 更換 */

	/* ---------------------------------------- [START] Active Hash */
	// 為了點Active，可以更換回Active Hash
	// 原因：因為Foundation Tab Active 時，再點 Active 不會更換，如果被 FAQ Accordion 更換後
	$('.page-sub-nav__link').on('click', function() {
		if (location.hash !== this.hash) {
			history.replaceState({}, '', this.hash); // 更新hash
		}
	})
	/* ---------------------------------------- [END] Active Hash */
	
})(window, document);
